import { showErrorMessage } from 'components/Helpers/Toasts';

const notImplementedMessage = 'Not implemented yet';

export const NotImplementedYetHandler = (e: React.SyntheticEvent): void => {
    showErrorMessage(notImplementedMessage);
    e.preventDefault();
};
